import React from 'react';
import { Router, Route } from 'react-router-dom';
import { connect } from 'react-redux';

import { history } from '../helpers';
import { Switch } from 'react-router-dom';

import { alertActions } from '../actions';
import { generalConstants } from '../constants';
import { PrivateRoute, Pages } from '../components/common';
import {
  NoPage,
  LoginPage,
  ForgotPage,
  ResetPage,
  SeoPage,
  HomePage,
  ProjectsPage,
  ProjectDetailPage,
  ClientsPage,
  ClientDetailPage,
  AboutPage
} from '../pages';

class App extends React.Component {
  constructor(props) {
    super(props);

    const { dispatch } = this.props;
    history.listen((location, action) => {
      // clear alert on location change
      dispatch(alertActions.clear());
    });

    this.state = {
      currentLocation: '',
      message: this.props.alert
    }
  }

  componentWillMount(){
    if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((position)=>{
            this.setState({currentLocation:position});
          });
      } else {
          console.log("Geolocation is not supported by this browser.");
      }
  }

  componentWillReceiveProps(nextProps) {
    
      window.setTimeout(() => {
        this.setState({
          message: null
        });
      }, 3000);
    
  }

  render() {
    const { alert } = this.props;
    const { message }  = this.state;
    
    return (
      <div>
        {message && <div className={`alert alert-fixed-top ${alert.type} alert-dismissible fade show`} role="alert">{alert.message} <button type="button" className="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true"><i className="fal fa-times"></i></span>
          </button></div>}
        <Router history={history} basename={generalConstants.URL}>
          <Pages>
            <Switch>
              <PrivateRoute exact path={generalConstants.URL} component={HomePage} />
              <PrivateRoute exact path={generalConstants.URL+"home"} component={HomePage} />

              <PrivateRoute exact path={generalConstants.URL+"clients"} component={ClientsPage} />
              <PrivateRoute exact path={generalConstants.URL+"client/"} component={ClientDetailPage} />
              <PrivateRoute path={generalConstants.URL+"client/:id"} component={ClientDetailPage} />

              <PrivateRoute exact path={generalConstants.URL+"projects"} component={ProjectsPage} />
              <PrivateRoute exact path={generalConstants.URL+"project/"} component={ProjectDetailPage} />
              <PrivateRoute path={generalConstants.URL+"project/:id"} component={ProjectDetailPage} />

              <PrivateRoute exact path={generalConstants.URL+"about"} component={AboutPage} />

              <PrivateRoute exact path={generalConstants.URL+"seo"} component={SeoPage} />

              <Route exact path={generalConstants.URL+"forgot"} component={ForgotPage} />
              <Route path={generalConstants.URL+"reset/:selector/:token"} component={ResetPage} />
              <Route exact path={generalConstants.URL+"login"} component={LoginPage} />
              <Route exact component={NoPage} />
            </Switch>
          </Pages>
        </Router>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { alert } = state;
  return {
    alert
  };
}

const connectedApp = connect(mapStateToProps)(App);
export { connectedApp as App };



// WEBPACK FOOTER //
// ./src/app/App.js